import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import { FormControl, RadioGroup } from '@mui/material';
import { toast } from 'react-hot-toast';
import ToastDisplay from '../../Utils/ToastDisplay';
import FControlLabel from '../shared/Forms/FControlLabel';
import Stepper from '../shared/Forms/Stepper';
import Divider from '../Divider';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import FormVideos from '../ModalEvaluacion/EvaluacionComponents/FormVideos';

interface IForm1 {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Form06: React.FC<IForm1> = (props) => {
  const navigate = useNavigate();

  
  useEffect(() => {
    window.scrollTo(0, 0);
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_SUPLEMENTOS,
      payload: '1',
    })
  }, []);

  const handleNext = () => {
    let error1 = false;
    let error2 = false;
    let error3 = false;

    if (props.state.objetivo === 'null') {
      return toast.error(
        <ToastDisplay title={`Hubo un error`} message={'Seleccione un objetivo'} />,
      );
    }
    if (props.state.cantidadComidas === 0) {
      error1 = true;
    }
    if (props.state.suplementos === undefined || props.state.suplementos === '') {
      error2 = true;
    }
    if (!error1 && !error2) {
      window.scrollTo(0, 0);
      props.dispatch({
        type: TipoAccionDetalle.CHANGE_NFORM,
        payload: props.state.nForm + 1,
      });
    }
    if (error1 || error2) {
      if (error1 && error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={
              'Seleccione si usa suplementos y la cantidad de comida que cosume al día'
            }
          />,
        );
      } else if (error1 && !error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Seleccione la cantidad de comida'}
          />,
        );
      } else if (!error1 && error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Seleccione los si usa suplementos'}
          />,
        );
      }
      error1 = false;
      error2 = false;
    }
  };
  
  return (
    <div
      className="mb-3 container flex flex-column justify-content-center align-items-center"
      style={{ margin: 'auto', minHeight: '75vh' }}
    >
        <FormVideos 
          url='https://player.vimeo.com/external/1047863156.m3u8?s=c3f7f781ca0983acea7390e18b3ccc60e8cd3a28&logging=false'
        />

      <div className="container form-macro mb-4">
        {/* <div>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ fontWeight: '700' }}>¿Usas suplementos?</h3>
            <Divider type="title" />
          </div>
          <div className="row">
            <div className="col-12" style={{ textAlign: 'left' }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={props.state.suplementos}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_SUPLEMENTOS,
                      payload: e.target.value === '1' ? '1' : '0',
                    });
                  }}
                >
                  <FControlLabel value={'1'} label="Sí" fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value={'0'} label="No" fontWeight={500} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div> */}
        <div>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ fontWeight: '700' }}>¿Cuántas comidas consumes al día?</h3>
            <Divider type="option" />
          </div>
          <div className="row">
            <div className="col-12" style={{ textAlign: 'left' }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={props.state.cantidadComidas}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_CANTIDADCOMIDAS,
                      payload: e.target.value,
                    });
                  }}
                >
                  <FControlLabel value="3" label="3 veces al día" fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value="4" label="4 veces al día" fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value="5" label="5 veces al día" fontWeight={500} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <Stepper
        state={props.state}
        dispatch={props.dispatch}
        handleNext={handleNext}
        mostrarAdvertencia={false}
      />
    </div>
  );
};

export default Form06;
